import { makeStyles } from "@fluentui/react-components";

export const useMyPlaybooksStyles = makeStyles({
  container: {
    marginTop: "1.5rem",
  },
  filters: {
    marginTop: "1.375rem",
  },
  filter: {
    minWidth: "unset",
  },
  playbooks: {
    marginTop: "0.5rem",
  },
});
